<template>
  <div>
    <div class="parent">
      <v-card>
        <v-card-title class="info-title">
          <div class="text-center text-padding">
            {{ item.TarhName }}
          </div>
        </v-card-title>
        <div>
          <app-row title="محل اعزام:" :value="item.MahaleEzam" />
          <app-row title="وضعیت:" :value="item.StateString" />
          <app-row title="تاریخ شروع:" :value="item.D_StartEzam" />
          <app-row title="تاریخ پایان:" :value="item.D_EndEzam" />
          <app-row title="مهلت انجام:" :value="item.D_Mohlat" />
        </div>
        <div style="padding: 15px">
          <v-row align="center">
            <v-col class="d-flex">
              <b>توضيحات فرد:</b>
            </v-col>
          </v-row>
          <v-row align="center">
            <v-col class="d-flex content">
              {{ item.Des_Fard }}
            </v-col>
          </v-row>
          <v-row align="center">
            <v-col class="d-flex">
              <b>توضيحات ستاد:</b>
            </v-col>
          </v-row>
          <v-row align="center">
            <v-col class="d-flex content">
              {{ item.Des_Setad }}
            </v-col>
          </v-row>
          <div :key="eIndex" v-for="eIndex in item.enserafs.length">
            <div class="hr-with-text">
              {{
                `درخواست انصراف در تاریخ ${item.enserafs[eIndex - 1].EnserafDate
                }`
              }}
            </div>
            <v-row align="center">
              <v-col class="d-flex">
                <b>توضيحات فرد:</b>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col class="d-flex content">
                {{ item.enserafs[eIndex - 1].Des_Fard }}
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col class="d-flex">
                <b>توضيحات ستاد:</b>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col class="d-flex content">
                {{ item.enserafs[eIndex - 1].Des_Setad }}
              </v-col>
            </v-row>
          </div>
          <v-row v-if="item.FardState == 0" class="ltr">
            <v-btn color="green white--text" class="register" rounded @click="$emit('showConfirm', item)">
              قبول ماموریت
            </v-btn>
          </v-row>
          <v-row v-if="item.FardState == 1" class="ltr">
            <v-btn color="green white--text" class="register" rounded @click="$emit('showReport', item)">
              گزارش کار
            </v-btn>
            <v-btn color="green white--text" class="register" rounded @click="$emit('showHokm', item.Fserial)">
              دریافت حکم
            </v-btn>
            <br />
            <v-btn class="valueButton" v-if="item.IsRemovable" color="red white--text" rounded
              @click="$emit('showCancel', item)">
              درخواست انصراف از اعزام
            </v-btn>
            <br />
          </v-row>
          <div style="padding: 5px"></div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import DetailRow from "@/components/DetailRow";
export default {
  props: ["item", "index"],
  computed: {},
  components: {
    appRow: DetailRow,
  },
};
</script>
<style scoped>
.register {
  margin: 20px 20px 0 20px !important;
}

.valueButton {
  margin-top: 20px;
}
</style>
